'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';

export default function GtagManager() {
  const pathname = usePathname();
  const isThankYouPage = pathname === '/thank-you';

  const GTAG_ID = process.env.NEXT_PUBLIC_GTM_ID ?? 'AW-16708617756';
  const CONVERSION_ID = process.env.NEXT_PUBLIC_GTM_CONVERSION_ID ?? 'AW-16708617756/ReumCJ3N0M4aEJyMpZ8-';

  // Don't render if GTAG_ID is not configured
  if (!GTAG_ID) {
    return null;
  }

  const baseScript = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GTAG_ID}');
  `;

  const conversionScript = isThankYouPage && CONVERSION_ID
    ? `
      gtag('event', 'conversion', {
        'send_to': '${CONVERSION_ID}',
        'value': 1.0,
        'currency': 'INR'
      });
    `
    : '';

  return (
    <>
      <Script async src={`https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`} />
      <Script
        id="gtag-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: baseScript + conversionScript,
        }}
      />
    </>
  );
}
